export const checkSailingParams = (queryVariables: Record<string, any>): boolean => {
    const cruiseId = queryVariables.get('cruiseId')
    const supplierCode = queryVariables.get('supplierCode')
    return Boolean(cruiseId) && Boolean(supplierCode)
}
